import Api from "../helpers/api";

export const LinkService = {
    save(params) {
        return Api.post("wakabox/email", params);
    },
    getDrawing(params) {
        return Api.get("wakabox/artwork?artworkType=coloring&photoId=" + params.photoId);
    },
    getStreamLink(params) {
        return Api.get("stream/link?wakartistId=" + params.wakartistId + "&storyId=" + params.storyId + "&seasonId=1" + "&episodeId=" + params.episodeId + "&photoId=" + params.photoId + "&label=WAKABOX&language=fr" );
    },
};